import styled from "styled-components";
import { responsive } from "theme/responsive";

export const OfferingsWrapper = styled.div`
   background: linear-gradient(219.81deg, #fa9445 16.01%, #c54dc0 44.99%, #7211d4 85.02%);
   border-radius: 40px;
   padding: 3em;
   color: #fff;
   margin: 4em 0;

   ${responsive("$small")`
   padding: 2em;
   `}

   div {
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      ${responsive("$small")`
      grid-template-columns: repeat(1, 1fr);
      gap: 2em;
      `}
   }
`;

export const OfferingsList = styled.ul`
   list-style: none;

   li {
      height: auto;
      margin: 1.5em 0;
      display: flex;
      align-items: flex-start;
      gap: 1em;

      div {
         h3 {
            margin-top: 0.75em;
            max-width: 425px;
            font-weight: 500;
         }

         p {
            font-size: 12px;
            line-height: 3;
            font-size: 14px;
            max-width: 386px;
         }

         display: flex;
         gap: 1em;
         flex-direction: column;
      }
   }
`;

export const OtherOfferingsWrapper = styled.div`
   display: grid;
   margin: 3em 0;
   grid-template-columns: repeat(2, 1fr);
   color: ${({ theme }) => theme.colors?.black};

   ${responsive("$small")`
   grid-template-columns: repeat(1, 1fr);
   `}
`;
